import React from "react";
import cx from "classnames";

import Typography from "@mui/material/Typography";
import { Accordion } from "@vedmarket/ui-kit";

import './support-accordion-card.scss'

type Props = {
  children: React.ReactNode;
  icon?: React.ReactElement<React.SVGProps<SVGSVGElement>>;
  iconVariant?: 'success' | 'warning';
  title: string;
}

const SupportAccordionCard = ({children, icon, iconVariant, title}: Props) => (
  <div className='support-accordion-card'>
    <Accordion
      defaultExpanded
      title={
        <div className='support-accordion-card__header-content'>
          {icon && (
            <span className={cx(
              'support-accordion-card__icon',
              iconVariant && `support-accordion-card__icon_${iconVariant}`
            )}>
              {React.cloneElement(icon, {className: cx('support-accordion-card__icon-image', icon.props.className)})}
            </span>
          )}
          <Typography
            variant='h6'
            sx={{fontWeight: 500, letterSpacing: 0, lineHeight: '28px'}}
          >
            {title}
          </Typography>
        </div>
      }
    >
      {children}
    </Accordion>
  </div>
);

export default SupportAccordionCard;
